var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"item",class:[
    'item',
    { selected: _vm.$parent.selected && _vm.$parent.selected.value === _vm.value }
  ],on:{"click":_vm.selectedElem}},[_vm._v(" "+_vm._s(this.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }